<mat-card class="full-height" style="padding-left: 0 !important; padding-top: 0 !important; padding-right: 0 !important;">
  <mat-card-header
    fxLayout="row"
    style="height: 4rem; padding-right: 24px;"
    fxLayoutAlign="center center"
  >
    <span fxFlex>
      <h1 class="subHeader">
        <ng-content select="[header-content]"> </ng-content>
      </h1>
    </span>
    <span>
      <ng-content select="[header-button-content]"></ng-content>
    </span>
  </mat-card-header>
  <mat-card-content class="content-general">
    <div style="width: 100%;">
      <div
        style="padding: 4rem"
        form-content
        fxFlexFill
        fxLayoutAlign="center center"
        *ngIf="!isLoaded"
      >
        <mat-spinner></mat-spinner>
      </div>
      <div class="form-container" [hidden]="!isLoaded">
        <ng-content
          select="[form-content]"
          fxFlexFill
          fxLayoutAlign="center center"
        ></ng-content>
      </div>
    </div>
  </mat-card-content>
</mat-card>
